import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { ItemTipoSituacaoModule } from './situacao';
import { IntegrationItemTipoSharedModule } from '../configuracoes/integration/item-tipo';

import { ItemTipoRoutingModule } from './item-tipo-routing.module';
import { ItemTipoComponent } from './item-tipo.component';
import { ItemTipoFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ItemTipoRoutingModule,
        ItemTipoSituacaoModule,
        IntegrationItemTipoSharedModule
    ],
    declarations: [
        ItemTipoComponent,
        ItemTipoFormComponent
    ]
})
export class ItemTipoModule { }
